import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right, #1b2330 0%, rgb(13, 17, 24) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ResetWrapper = styled.div`
  background: white;
  border-radius: 30px;
  width: 60%;
  max-width: 600px;
  min-width: 300px !important;
`

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  img {
    width: 80%;
    max-width: 300px;
    margin-top: 4rem;
  }

  form {
    margin-left: 1rem;
    margin-top: 7rem;
    width: 80%;
    height: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: none;

    input {
      color: rgb(74, 74, 74);
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      padding: 15px;
      width: 70%;
      border: none;
      background-color: #252f3e;
      border-radius: 20px;
      margin: 2rem auto;

      &:disabled {
        background-color: #7c818a;
        cursor: not-allowed;
      }
    }
  }
`
